import { render, staticRenderFns } from "./contentCategoryDelete.vue?vue&type=template&id=fbf69ce8&"
import script from "./contentCategoryDelete.vue?vue&type=script&lang=js&"
export * from "./contentCategoryDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports